import React, { useEffect, useState } from 'react';
import { Modal, Table, Checkbox, Tag, message } from 'antd';
import { apiRequest } from '../../../service/apiRequest';  // your API util
import { showSuccess, showError } from '../../../components/errorHandler';


interface ExamItem {
  exam_id: number;
  exam_name: string;
  eom_id:string | null;
  exam_status:number;
}

interface Props {
  visible: boolean;
  onCancel: () => void;
  examData: ExamItem[];
  organizationId: string; // pass org id to link exams
  onSaved: () => void; // callback after successful save
}

const ExamOrgMapping: React.FC<Props> = ({
  visible,
  onCancel,
  examData,
  organizationId,
  onSaved,
}) => {
  const [selectedExamIds, setselectedExamIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mappedIds = examData
      .filter((mdl) => mdl.eom_id !== null)
      .map((mdl) => mdl.exam_id);
    setselectedExamIds(mappedIds);
  }, [examData]);

  const onCheckChange = (examId: number, checked: boolean) => {
    setselectedExamIds((prev) =>
      checked ? [...prev, examId] : prev.filter((id) => id !== examId)
    );
  };

  const columns = [
    {
      title: 'Exam Name',
      dataIndex: 'exam_name',
      key: 'exam_name',
    },
    {
      title: 'Status',
      dataIndex: 'exam_status',
      key: 'exam_status',
      render: (status: number) =>
        status === 1 ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: 'Mapped',
      dataIndex: 'eom_id',
      key: 'mapped',
      render: (eom_id: string | null) =>
        eom_id ? (
          <Tag color="blue">Mapped</Tag>
        ) : (
          <Tag color="default">Not Mapped</Tag>
        ),
    },
    {
      title: 'Select',
      key: 'select',
      render: (_: any, record: ExamItem) => (
        <Checkbox
          checked={selectedExamIds.includes(record.exam_id)}
          onChange={(e) => onCheckChange(record.exam_id, e.target.checked)}
        />
      ),
    },
  ];

  const handleSave = async () => {
    setLoading(true);
    try {
      // API call - replace URL & payload as needed
      await apiRequest({
        method: 'put',
        url: `/map-exam-to-organization/${organizationId}`, // example endpoint
        data: { exam_ids: selectedExamIds },
      });
      showSuccess('exams mapped successfully');
      onSaved(); // notify parent to refresh or close modal
      onCancel();
    } catch (error) {
      console.error(error);
      showError('Failed to save exam mappings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Map Exams to Organization"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save"
      confirmLoading={loading}
      width={600}
    >
      <Table
        rowKey="exam_id"
        dataSource={examData}
        columns={columns}
        pagination={false}
        scroll={{ y: 300 }}
      />
    </Modal>
  );
};

export default ExamOrgMapping;
